module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjys_hy1000@2x.4a25b060.png";